import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Select, Modal, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { useNavigate } from "react-router-dom";
import {
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import {
  formatDateNoTime,
  // getRestoLogin,
  getRole,
  formatAmount,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import MytFooter from "../../Components/MytFooter";
// import { recordUserActivityLog } from "../../Helpers/apiCalls/authApi";
const { confirm } = Modal;

function XReading() {
  const navigate = useNavigate();
  const role = getRole();
  const [inactive, setInactive] = useState(true);
  const [printingInProgress, setPrintingInProgress] = useState(false);
  const [eodInProgress, setEodInProgress] = useState(false);
  const [reportDetails, setReportDetails] = useState({});
  const [otherDiscounts, setOtherDiscounts] = useState([]);
  const [cashLedgers, setCashLedgers] = useState([]);
  const [creditLedgers, setCreditLedgers] = useState([]);
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    cashier_id: "",
  });
  const [allData, setAllData] = useState({});
  const [cashierOptions, setCashierOptions] = useState([]);


  const confirmCancel = () => {
    confirm({
      title: `Are you sure you want to EOD - ${formatDateNoTime(filter.date_from)}?`,
      icon: <ExclamationCircleOutlined className="warning-icon" />,
      content: (
        <>
          <Row className="modal-text">You cannot undo this action.</Row>
        </>
      ),
      okText: "CONFIRM",
      cancelText: "CANCEL",
      onOk: () => { 
        // recordUserActivityLog("Clicked Xreading EOD button");
        fetchReport("zcounter")
      },
      okType: "primary",
      width: 600,
    });
  };

  async function fetchReport(type) {
    const payload = {
      date_from: filter.date_from,
      date_to: filter.date_from,
      cashier_id: filter.cashier_id,
      type: type,
    };

    if (type === "zcounter") {
      setEodInProgress(true)

      const response = await UseGetRequest(
        "reports/eod",
        payload,
        // getRestoLogin()
      );
      if (response.data) {
        toast.success("EOD Successful!", { style: toastStyle() });
        setEodInProgress(false)
        setTimeout(() => {
          refreshPage();
        }, 1000);
      } else {
        setEodInProgress(false)
        toast.error("EOD Failed", { style: toastStyle() });
      }
    } else {
      const response = await UseGetRequest(
        "reports/xreading",
        payload,
        // getRestoLogin()
      ); 
      if (response.data) {
        setReportDetails(response.data.data.reports);
        const tempDisc = response.data.data.reports.other_discount.map(
          (row) => {
            let tempName;
            if (row.name?.toLowerCase() === "employee") {
              tempName = "Employee Disc";
            } else if (row.name?.toLowerCase() === "max senior/pwd") {
              tempName = "Max SR/PWD";
            } else if (row.name?.toLowerCase() === "open discount amount") {
              tempName = "Open Disc Amt";
            } else if (row.name?.toLowerCase() === "open discount rate") {
              tempName = "Open Disc Rate";
            } else if (row.name?.toLowerCase() === "regular") {
              tempName = "Regular";
            } else if (row.name?.toLowerCase() === "open item discount") {
              tempName = "Open Item Discount";
            } else {
              tempName = row.name;
            }
            return {
              ...row,
              name: tempName,
            };
          }
        );
        setOtherDiscounts(tempDisc);
        setCashLedgers(response.data.data.cash_ledger.cash_ledgers);
        setCreditLedgers(response.data.data.credit_ledger.credit_ledgers);
        setAllData(response.data.data);
        const report = [response.data.data.reports];

        report.push({
          media_summary_cash:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.cash,
          media_summary_credit:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.credit,
          media_summary_gc:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.gc,
          cash_ledger_sales:
            "TOTAL: " + response.data.data.cash_ledger.total_cash,
          credit_ledger_sales:
            "TOTAL: " + response.data.data.credit_ledger.total_credit,
          total_ledger_gc_coupon:
            "TOTAL: " + response.data.data.gc_coupon.total_gc_coupon,
        });

      }
    }

    // if (type==="zcounter") {
    //   setTimeout(() => {
    //     handlePrint();
    // }, 500)}
  }

  const printRef = useRef(null); // Initialize useRef with null
  const tempRef = useRef(null);

  // Handle for export to pdf
  const handleExportPDF = (e) => {
    // const pdf = new jsPDF();
    // const content = tempRef.current;
    // html2canvas(content).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const imgWidth = 200; // Set the width of the image (A4 size)
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   const x = (pdf.internal.pageSize.width - imgWidth) / 2;
    //   pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
    //   pdf.save("X Reading Report.pdf");
    // });
    const pdf = new jsPDF();
    const content = tempRef.current;

    html2canvas(content).then((canvas) => {
      const imgWidth = 200; 
      // const pageHeight = pdf.internal.pageSize.height; 
      const pageHeight = 281; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Scaled height of the image
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      let heightLeft = canvasHeight;
      let position = 0;

      while (heightLeft > 0) {
        const canvasSection = document.createElement("canvas");
        canvasSection.width = canvasWidth;
        canvasSection.height = Math.min(heightLeft, (pageHeight * canvasWidth) / imgWidth);

        const ctx = canvasSection.getContext("2d");
        ctx.drawImage(canvas, 0, position, canvasWidth, canvasSection.height, 0, 0, canvasWidth, canvasSection.height);

        const sectionData = canvasSection.toDataURL("image/png");
        const x = (pdf.internal.pageSize.width - imgWidth) / 2;

        pdf.addImage(sectionData, "PNG", x, 10, imgWidth, (canvasSection.height * imgWidth) / canvasWidth);

        heightLeft -= canvasSection.height;
        position += canvasSection.height;

        if (heightLeft > 0) {
          pdf.addPage();
        }
      }

      pdf.save("X Reading Report.pdf");
    });
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const [allowPrint, setAllowPrint] = useState(false);

  const handlePrint = () => {
    // setIsClicked(true)
    setAllowPrint(true);
    setPrintingInProgress(true)
    setTimeout(() => {
      if (printRef.current) {
        const element = printRef.current;
  
        // Apply custom CSS for the desired paper size (80mm x 297mm)
        element.style.width = "var(--receipt-width)";
        html2canvas(element, { scale: 1 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          printBase64Data(imgData);
          toast.success("Processing...", {
            style: toastStyle(),
          });
          setPrintingInProgress(false)
        });
      } else {
        setPrintingInProgress(false)
      }
    }, 2000)
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      // getRestoLogin()
    );
    if (response.data) {
      refreshPage();
    }
    setAllowPrint(false);
  }

  async function fetchAllCashiers() {
    const response = await UseGetRequest(
      "users/getAll",
      { role: "2" },
      // getRestoLogin()
    );
    setCashierOptions([]);
    if (response.data) {
      const res = response.data.users.map((row) => {
        return {
          label: row.full_name,
          value: row.id,
        };
      });
      setCashierOptions([{ value: "", label: "All" }, ...res]);
    }
  }
  // API CALLS REACT USE EFFECT
  // useEffect(() => {
  //   if (allowPrint) {
  //     handlePrint();
  //   }
  // }, [allowPrint]);

  useEffect(() => {
    fetchReport("print");
  }, [filter]);

  useEffect(() => {
    fetchAllCashiers();
  }, []);

  return (
    <div className="page">
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      <div
        className={`container ps-5 pt-4 bold-font ${
          role === "" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col>
            <h1 className="page-title-menu">X READING REPORT</h1>
          </Col>
          <Col className="d-flex justify-content-end mb-2">
            <button
              className="category-new-export-btn"
              onClick={() => handlePrint()}
            >
              PRINT
            </button>
            &nbsp;&nbsp;
            {(getRole() === "1" || getRole() === "7") && (
              <button
                className="category-new-export-btn"
                disabled={reportDetails.gross_sales === null || reportDetails.gross_sales === '0.00'}
                onClick={confirmCancel}
              >
                EOD
              </button>
            )}
            &nbsp;&nbsp;
            <button
              className="category-new-export-btn"
              value="pdf"
              onClick={(e) => handleExportPDF(e.target.value)}
            >
              EXPORT TO PDF
            </button>
            &nbsp;&nbsp;
            {/* {role !== "1" && (
              <button
                className="category-new-export-btn"
                value="pdf"
                onClick={() => navigate(-1)}
              >
                BACK
              </button>
            )} */}
          </Col>
          <hr />
        </Row>
        {(getRole() === "1" || getRole() === "7") && (
          <div className="my-2 px-4 PO-filters d-flex">
            <span className="me-4 align-middle mt-2"> DATE:</span>
            <Col xs={2}>
              <Form.Control
                size="sm"
                type="date"
                name="date_from"
                className="w-100"
                onChange={handleFilter}
                value={filter.date_from}
              />
            </Col>
            {/* <Col xs={3}>
              <Select
                className="w-100"
                options={cashierOptions}
                placeholder="Select cashier"
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, cashier_id: e }))
                }
              />
            </Col> */}
          </div>
        )}

        <div className="redo-x-z-reading-cont p-5">
          <Row ref={allowPrint ? printRef : tempRef}>
            <Col>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center  print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <Row className=" print-text">
                <Col>
                  <strong>X Reading</strong>
                </Col>
              </Row>
              <Row className=" print-text">
                <Col>
                  <label>{formatDateNoTime(new Date(filter.date_from))}</label>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Gross Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.gross_sales
                        ? reportDetails.gross_sales
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Sales Net of Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.net_sales ? reportDetails.net_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.tax_sales ? reportDetails.tax_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Vat Exempt Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.vat_exempt_sales
                        ? reportDetails.vat_exempt_sales
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Zero-Rated</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.zero_rated
                        ? reportDetails.zero_rated
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Ave Bill/Guest</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.avg_bill_per_guest
                        ? reportDetails.avg_bill_per_guest
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Ave Bill/Trans</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.avg_bill_per_transaction
                        ? reportDetails.avg_bill_per_transaction
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              {/* <Row>
                <Col className="print-text" xs={10}>
                  <label>Transaction Count</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.transaction_count
                        ? reportDetails.transaction_count
                        : "0"
                    )}
                  </label>
                </Col>
              </Row> */}
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Guest Count</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.guest_count
                        ? reportDetails.guest_count
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Transaction Count</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.no_of_transactions
                        ? reportDetails.no_of_transactions
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Quantity</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_qty ? reportDetails.total_qty : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Subtotal Discount</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.subtotal_discount
                        ? reportDetails.subtotal_discount
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. of Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.no_of_cancelled_si
                        ? reportDetails.no_of_cancelled_si
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Amount Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.amount_cancelled
                        ? reportDetails.amount_cancelled
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Senior Citizen Disc</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.s_citizen_disc
                        ? reportDetails.s_citizen_disc
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. Senior Citizen Disc</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.no_s_citizen_disc
                        ? reportDetails.no_s_citizen_disc
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>S. Citizen Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.s_citizen_vat_exempt
                        ? reportDetails.s_citizen_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>PWD Disc</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.pwd_disc ? reportDetails.pwd_disc : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. PWD Disc</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.no_pwd_disc
                        ? reportDetails.no_pwd_disc
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>PWD Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.pwd_vat_exempt
                        ? reportDetails.pwd_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              {otherDiscounts.map((data) => (
                <>
                  <Row>
                    <Col className="print-text" xs={10}>
                      <Row>
                        <label>{data.name}</label>
                        <label>No. {data.name}</label>
                      </Row>
                    </Col>
                    <Col
                      className="d-flex justify-content-end text-right print-text"
                      xs={2}
                    >
                      <Row>
                        <label>
                          {parseFloat(
                            data.total_discount > 0 ? data.total_discount : 0.0
                          ).toFixed(2)}
                        </label>

                        <label>
                          {data.no_of_discount ? data.no_of_discount : 0}
                        </label>
                      </Row>
                    </Col>
                  </Row>
                </>
              ))}
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Open Item VAT Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.open_item_vat_exempt
                        ? reportDetails.open_item_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Service Charge</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_service_charge
                        ? reportDetails.total_service_charge
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>

              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Vat</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.expanded_value_added_tax
                        ? reportDetails.expanded_value_added_tax
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.no_expanded_value_added_tax
                        ? reportDetails.no_expanded_value_added_tax
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Cash Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_cash_sales
                        ? reportDetails.total_cash_sales
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Card Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_card
                        ? reportDetails.total_card
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Foodpanda Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_foodpanda
                        ? reportDetails.total_foodpanda
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Grab Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_grab
                        ? reportDetails.total_grab
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Gcash Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_gcash
                        ? reportDetails.total_gcash
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Maya Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_maya
                        ? reportDetails.total_maya
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Qr PH Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_qrph
                        ? reportDetails.total_qrph
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Charge Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_charge
                        ? reportDetails.total_charge
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Coupon</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      reportDetails.total_coupon
                        ? reportDetails.total_coupon
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text ms-2" xs={10}>
                  <label>Cash Ledger</label>
                </Col>
                {cashLedgers?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text" xs={10}>
                        <label>{data.cashier}</label>
                      </Col>
                      <Col
                        className="d-flex justify-content-end  print-text"
                        xs={2}
                      >
                        <label>
                          {formatAmount(parseFloat(data.total_cash).toFixed(2))}
                        </label>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
              <Row>
                <Col className="print-text ms-2" xs={10}>
                  <label>Credit Ledger</label>
                </Col>
                {creditLedgers?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text" xs={10}>
                        <label>{data.cashier}</label>
                      </Col>
                      <Col
                        className="d-flex justify-content-end  print-text"
                        xs={2}
                      >
                        <label>
                          {formatAmount(
                            parseFloat(data.total_credit).toFixed(2)
                          )}
                        </label>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Media Summary</label>
                </Col>
              </Row>
              <Row className="print-text ms-4">
                <Col className="d-flex justify-content-left print-text" xs={5}>
                  <label>
                    Cash :{" "}
                    {allData.media_summary
                      ? formatAmount(
                          parseFloat(
                            allData.media_summary.media_summary.cash
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
                <Col className="d-flex justify-content-left  print-text" xs={5}>
                  <label>
                    Credit :{" "}
                    {allData.media_summary
                      ? formatAmount(
                          parseFloat(
                            allData.media_summary.media_summary.credit
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className=" print-text">
                  <label>Beg. SI</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text">
                  <label>{allData.beg_si}</label>
                </Col>
              </Row>
              <Row>
                <Col className=" print-text">
                  <label>End SI</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text">
                  <label>{allData.end_si}</label>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text smaller-text">
                  <label>{window.myt_address1}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_address2}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label> {window.myt_acc_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_issued_date}</label>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <MytFooter/>


      <Modal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <Row className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large"/>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </Modal>

      <Modal
        maskClosable={false}
        open={eodInProgress}
        footer={null}
        closeIcon={false}
      >
        <Row className="d-flex justify-content-center">
          <Title level={5}>EOD IN PROGRESS</Title>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large"/>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </Modal>
      </div>
    </div>
  );
}

export default XReading;
